import Vue from 'vue';
import './plugins/vuetify';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-60864506-4',
  router,
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
